import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tender} from '../../../../../../../domain/funding-tender/funding-tender-data';
import {TranslateService} from '@ngx-translate/core';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {WidgetSize} from '../../../../../../../domain/widget/model/widget-size.enum';

@Component({
  selector: 'app-widget-funding-tender-specifications',
  templateUrl: './home-dashboard-widget-funding-tender-specifications.component.html'
})
export class HomeDashboardWidgetFundingTenderSpecificationsComponent implements OnInit {

  @Input() widget: WidgetDetail;
  @Input() tender: Tender;
  WidgetSize = WidgetSize;

  @Output() actionEvent = new EventEmitter<string>();

  constructor(private translateService: TranslateService,
              private domainUrlService: DomainUrlService,
              private userContextService: UserContextService) { }

  ngOnInit(): void {
  }

  public goToFundingTenderSpecifications(): string {
    let receiptPageUrl = this.domainUrlService.getFundingtenderUrl() + '/tender/' + this.tender.id + '/specifications';
    const accountId = this.userContextService.getUserContext().accountId;
    receiptPageUrl += accountId != null ? '?accountId=' + accountId : '';
    return receiptPageUrl;
  }

}
